import { render, staticRenderFns } from "./SolicitudCompra.vue?vue&type=template&id=b909e534&scoped=true"
import script from "./SolicitudCompra.vue?vue&type=script&lang=js"
export * from "./SolicitudCompra.vue?vue&type=script&lang=js"
import style0 from "./SolicitudCompra.vue?vue&type=style&index=0&id=b909e534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b909e534",
  null
  
)

export default component.exports